import { Info } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import type { FivetranConnection } from "./fivetran";
import {
  getStatusBadgeVariant,
  getStatusIcon,
  getStatusLabel,
} from "./fivetran";

interface ConnectionStatusCardProps {
  connection: FivetranConnection;
}

export function ConnectionStatusCard({
  connection,
}: ConnectionStatusCardProps) {
  return (
    <Card className="mb-6">
      <CardHeader>
        <div className="flex items-center justify-between">
          <CardTitle className="flex items-center gap-2">
            <Info className="h-5 w-5" />
            Current Connection Status
          </CardTitle>
          <div className="flex items-center gap-2">
            {getStatusIcon(connection.setup_state)}
            <Badge variant={getStatusBadgeVariant(connection.setup_state)}>
              {getStatusLabel(connection.setup_state)}
            </Badge>
          </div>
        </div>
      </CardHeader>
      <CardContent>
        <div className="space-y-2 text-sm">
          <div>
            <span className="font-medium">Environment:</span>{" "}
            {connection.environment}
          </div>
          <div>
            <span className="font-medium">Created:</span>{" "}
            {new Date(connection.created_at).toLocaleDateString()}
          </div>
          <div>
            <span className="font-medium">Last Updated:</span>{" "}
            {new Date(connection.updated_at).toLocaleDateString()}
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
